import React from "react";

const InstagramWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16.5 5.5h.01M6 1h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V6a5 5 0 0 1 5-5m9 9.37a4 4 0 1 1-7.914 1.174A4 4 0 0 1 15 10.37"
      ></path>
    </svg>
  );
};

export default InstagramWhiteIcon;
